<template>
    <div class="publishers-container shadow-sm">
        <div class="modal fade" id="editMessageModal" tabindex="-1" aria-labelledby="editMessageModal" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable">
                <div class="modal-content"  v-if="this.editedMessage != null">
                    <div class="modal-header">
                        <!--<h5 class="modal-title" v-if="this.editedMessage != null && this.editedMessage.id != null">{{ $t("admin.opening_messages.edit_dialog.edit_title") }}</h5>
                        <h5 class="modal-title" v-if="this.editedMessage != null && this.editedMessage.id == null">{{ $t("admin.opening_messages.edit_dialog.new_title") }}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>-->
                    </div>
                    <div class="modal-body">
                        <!--<h5>{{ $t("admin.opening_messages.edit_dialog.title_label") }}</h5>
                        <div class="mb-3">
                            <label for="title_english" class="form-label">{{ $t("admin.opening_messages.edit_dialog.english_label") }}</label>
                            <input type="text" class="form-control" id="title_english" v-model="editedMessage.title.en">
                        </div>
                        <div class="mb-3">
                            <label for="title_french" class="form-label">{{ $t("admin.opening_messages.edit_dialog.french_label") }}</label>
                            <input type="text" class="form-control" id="title_french" v-model="editedMessage.title.fr">
                        </div>

                        <h5>{{ $t("admin.opening_messages.edit_dialog.message_label") }}</h5>
                        <div class="mb-3">
                            <label for="message_english" class="form-label">{{ $t("admin.opening_messages.edit_dialog.english_label") }}</label>
                            <textarea class="form-control" id="message_english" v-model="editedMessage.message.en"></textarea>
                        </div>
                        <div class="mb-3">
                            <label for="message_french" class="form-label">{{ $t("admin.opening_messages.edit_dialog.french_label") }}</label>
                            <textarea type="text" class="form-control" id="message_french" v-model="editedMessage.message.fr"></textarea>
                        </div>

                        <h5>{{ $t("admin.opening_messages.edit_dialog.parameters_label") }}</h5>
                        <div class="mb-3">
                            <label for="frequency_select" class="form-label">{{ $t("admin.opening_messages.edit_dialog.frequency_label") }}</label>
                            <select type="text" class="form-control" id="frequency_select" v-model="editedMessage.frequency">
                                <option value="always">{{ $t("enums.frequency.always") }}</option>
                                <option value="once">{{ $t("enums.frequency.once") }}</option>
                                <option value="onceAMinute">{{ $t("enums.frequency.once_a_minute") }}</option>
                                <option value="onceAnHour">{{ $t("enums.frequency.once_an_hour") }}</option>
                                <option value="onceADay">{{ $t("enums.frequency.once_a_day") }}</option>
                                <option value="onceAWeek">{{ $t("enums.frequency.once_a_week") }}</option>
                                <option value="onceAMonth">{{ $t("enums.frequency.once_a_month") }}</option>
                            </select>
                        </div>

                        <div class="mb-3">
                            <label for="startDate" class="form-label">{{ $t("admin.opening_messages.edit_dialog.start_date_label") }}</label>
                            <DateSelector class="form-control start-date-input" id="startDate" v-model="editedMessageStartDate" mode="dateTime"></DateSelector>
                        </div>

                        <div class="mb-3">
                            <label for="endDate" class="form-label">{{ $t("admin.opening_messages.edit_dialog.end_date_label") }}</label>
                            <DateSelector class="form-control end-date-input" id="endDate" v-model="editedMessageEndDate" mode="dateTime"></DateSelector>
                        </div>-->
                    </div>
                    <div class="modal-footer">
                        <!--<button type="button" class="btn btn-secondary" v-on:click="handleCloseEditedMessageClicked()" >{{ $t("admin.opening_messages.edit_dialog.close_button") }}</button>
                        <button type="button" class="btn btn-primary" v-on:click="handleSaveAsDraftEditedMessageClicked()">{{ $t("admin.opening_messages.edit_dialog.save_as_draft_button") }}</button>
                        <button type="button" class="btn btn-primary" v-on:click="handleSaveAndPublishEditedMessageClicked()">{{ $t("admin.opening_messages.edit_dialog.save_and_publish_button") }}</button>-->
                    </div>
                </div>
            </div>
        </div>

        <YesNoAlert ref="confirmDeleteAlert" id="confirmDeleteAlert" v-bind:title="$t('admin.opening_messages.confirm_delete_title')" v-bind:message="$t('admin.opening_messages.confirm_delete_message')" v-on:yes="handleDeleteMessageConfirmed()" />

        <div class="toolbar">
            <button class="btn btn-primary btn-sm" v-on:click="handleNewMessageClicked()">{{ $t("admin.system.publisher.new_publisher_button") }}</button>
        </div>

        <ul class="publishers-list">
            <li class="publisher-container header">
                <div class="publisher-title header">{{ $t("admin.system.publisher.publisher_header") }}</div>
                <div class="publisher-actions header">{{ $t("admin.system.publisher.actions_header") }}</div>
            </li>
        </ul>
        <div v-if="!publishers || publishers.length == 0" class="empty-list">{{ $t("admin.system.publisher.no_publishers_label") }}</div>
        <div class="publisher-list-container">
            <ul class="publishers-list scrolling-area">
                <li class="publisher-container" v-for="publisher of publishers" v-bind:key="publisher.id">
                    <div class="publisher-name">{{ publisherName(publisher) }}</div>
                    <div class="message-actions">
                        <button class="btn btn-primary btn-sm" v-on:click="handleEditPublisherClicked(publisher)">{{ $t("admin.system.edit_button") }}</button>
                        <!--<button class="btn btn-primary btn-sm" v-on:click="handleEditMessageClicked(message)">{{ $t("admin.opening_messages.edit_button") }}</button>
                        <button v-if="message.active == false" class="btn btn-success btn-sm" v-on:click="handlePublishButtonClicked(message)">{{ $t("admin.opening_messages.publish_button") }}</button>
                        <button v-if="message.active == true" class="btn btn-info btn-sm" v-on:click="handleMarkAsDraftButtonClicked(message)">{{ $t("admin.opening_messages.mark_as_draft_button") }}</button>
                        <button class="btn btn-danger btn-sm" v-on:click="handleDeleteMessageClicked(message)">{{ $t("admin.opening_messages.delete_button") }}</button>-->
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
// import DateSelector from "@/views/ui/dateselector/DateSelector.vue"
import MapOpeningMessageService from "@/service/MapOpeningMessageService.js";
import MapService from "@/service/MapService.js";
import PublisherService from "@/service/PublisherService.js";
//import Publisher from "@/model/Publisher/js";
import MapOpeningMessage from "@/model/MapOpeningMessage.js";
import LangUtils from '@/utils/LangUtils';
import DateUtils from '@/utils/DateUtils';
import YesNoAlert from "@/views/ui/alert/YesNoAlert"
import * as moment from 'moment';

export default {
    name: "OpeningMessagesEditor",

    components: {
//        DateSelector,
        YesNoAlert
    },

    data() {
        return {
            publishers: null,
            editedPublisher: null,
            editionModal: null,
            publisherToDelete: null,
            publisherService: new PublisherService(),
            mapOpeningMessageService: new MapOpeningMessageService(),
            mapService: new MapService()
        }
    },

    props: {
        publisherId: String,
        mapId: String
    },

    computed: {
        editedMessageStartDate: {
            get: function() {
                return this.editedMessage.startDate ? DateUtils.formatForDateTimeInput(new Date(this.editedMessage.startDate)) : null;
            },

            set: function(newValue) {
                if (this.editedMessage) {
                    this.editedMessage.startDate = newValue != null ? Date.parse(newValue) : null;
                }

                if (this.editedMessage.startDate == null) {
                    this.$forceUpdate();
                }
            }
        },

        editedMessageEndDate: {
            get: function() {
                return this.editedMessage.endDate ? DateUtils.formatForDateTimeInput(new Date(this.editedMessage.endDate)) : null;
            },

            set: function(newValue) {
                if (this.editedMessage) {
                    this.editedMessage.endDate = newValue != null ? Date.parse(newValue) : null;
                }

                if (this.editedMessage.endDate == null) {
                    this.$forceUpdate();
                }
            }
        }
    },

    watch: {
        editedMessage: function() {
            if (this.editedMessage != null) {
                this.editionModal.show();
            } else {
                this.editionModal.hide();
            }
        }
    },

    methods: {
        loadPublishers() {
            this.publisherService.loadPublishers().then((publishers) => {
                if (publishers) {
                    publishers.sort((publisher1, publisher2) => {
                        const publisher1Name = LangUtils.valueForLanguage(publisher1.name, this.$i18n.locale);
                        const publisher2Name = LangUtils.valueForLanguage(publisher2.name, this.$i18n.locale);

                        if (publisher1Name < publisher2Name) {
                            return -1;
                        }
                        if (publisher1Name > publisher2Name) {
                            return 1;
                        }
                        return 0;
                    });
                }

                this.publishers = publishers;
            }).catch((error) => {
                console.log(error);
            });
        },

        publisherName(publisher) {
            return publisher.name ? LangUtils.valueForLanguage(publisher.name, this.$i18n.locale) : publisher.id;
        },

/////////////////////////////////
        loadMessages() {
            this.mapOpeningMessageService.loadOpeningMessagesForMap(this.publisherId, this.mapId).then((openingMessages) => {
                this.messages = openingMessages;
            }).catch((error) => {
                console.log(error);
            });
        },

        saveMessage(message) {
            message.lastUpdate = new Date().getTime();

            this.mapService.loadMapForPublisher(this.publisherId, this.mapId).then((map) => {
                this.mapOpeningMessageService.saveMapOpeningMessage(this.$store.state.currentPublisher.id, message, map.legacyOpeningMessages).then(() => {
                    if (map.legacyOpeningMessages) {
                        this.mapService.touchMapBundlesForMap(this.publisherId, map);
                    }

                    this.editedMessage = null;
                    this.messageToDelete = null;
                    this.loadMessages();
                }).catch((error) => {
                    console.log(error);
                });
            }).catch((error) => {
                console.log(error);
            });
        },

        deleteMessage(message) {
            this.mapOpeningMessageService.deleteMapOpeningMessage(this.$store.state.currentPublisher.id, this.mapId, message.id).then(() => {
                this.mapService.loadMapForPublisher(this.publisherId, this.mapId).then((map) => {
                    if (map.legacyOpeningMessages) {
                        this.mapService.touchMapBundlesForMap(this.publisherId, map);
                    }
                    this.loadMessages();
                }).catch((error) => {
                    console.log(error);
                });
            }).catch((error) => {
                console.log(error);
            });
        },

        messageTitle(message) {
            return LangUtils.valueForLanguage(message.title, this.$i18n.locale);
        },

        messageContent(message) {
            return LangUtils.valueForLanguage(message.message, this.$i18n.locale);
        },

        messageParameters(message) {
            var parametersString = "";

            parametersString = this.$t("admin.opening_messages.edit_dialog.frequency_label") + ": ";
            switch(message.frequency) {
                case "always":
                    parametersString = parametersString + " " + this.$t("enums.frequency.always");
                    break;
                case "once":
                    parametersString = parametersString + " " + this.$t("enums.frequency.once");
                    break;
                case "onceAMinute":
                    parametersString = parametersString + " " + this.$t("enums.frequency.once_a_minute");
                    break;
                case "onceAnHour": 
                    parametersString = parametersString + " " + this.$t("enums.frequency.once_an_hour");
                    break;
                case "onceADay":
                    parametersString = parametersString + " " + this.$t("enums.frequency.once_a_day");
                    break;
                case "onceAWeek":
                    parametersString = parametersString + " " + this.$t("enums.frequency.once_a_week");
                    break;
                case "onceAMonth":
                    parametersString = parametersString + " " + this.$t("enums.frequency.once_a_month");
                    break;
                default:
                    parametersString = parametersString + " " + this.$t("enums.frequency.always");
                    break;
            }

            return parametersString;
        },

        messageLastUpdatedOn(message) {
            if (message.lastUpdate) {
                return moment(new Date(message.lastUpdate)).format("YYYY-MM-DD hh:mm");
            } else {
                return this.$t("admin.opening_messages.not_available_label");
            }
        },

        handleNewMessageClicked() {
            this.editedMessage = new MapOpeningMessage();
            this.editedMessage.active = true;
            this.editedMessage.mapIds = {};
            this.editedMessage.title = {
                en: null,
                fr: null
            }
            this.editedMessage.message = {
                en: null,
                fr: null
            }
            this.editedMessage.mapIds[this.mapId] = true;
            this.editedMessage.frequency = "always";
        },

        handleEditMessageClicked(message) {
            this.editedMessage = new MapOpeningMessage(JSON.parse(JSON.stringify(message)));
            if (!this.editedMessage.title) {
                this.editedMessage.title = {
                    en: null,
                    fr: null
                }
            }

            if (!this.editedMessage.message) {
                this.editedMessage.message = {
                    en: null,
                    fr: null
                }
            }

            if (!this.editedMessage.frequency) {
                this.editedMessage.frequency = "always";
            }
        },

        handlePublishButtonClicked(message) {
            message.active = true;
            this.saveMessage(message);
        },

        handleMarkAsDraftButtonClicked(message) {
            message.active = false;
            this.saveMessage(message);
        },

        handleDeleteMessageClicked(message) {
            this.messageToDelete = message;
            this.$refs.confirmDeleteAlert.show();
        },

        handleDeleteMessageConfirmed() {
            if (this.messageToDelete) {
                this.deleteMessage(this.messageToDelete);
            }
        },

        handleCloseEditedMessageClicked() {
            this.editedMessage = null;
        },

        handleSaveAsDraftEditedMessageClicked() {
            this.editedMessage.active = false;
            this.saveMessage(this.editedMessage);
        },

        handleSaveAndPublishEditedMessageClicked() {
            this.editedMessage.active = true;
            this.saveMessage(this.editedMessage);
        }
    },

    mounted() {
        this.editionModal = new this.bootstrap.Modal(document.getElementById('editMessageModal'));

        this.loadPublishers();
    }
}
</script>

<style scoped>
.publishers-container {
    background-color: #ffffff;
    margin: 0 auto;
    padding: 24px;
    text-align: left;
    width: 100%;
    height: 100%;

    display: flex;
    flex-direction: column;
}

.publisher-list-container {
    width: 100%;
    height: 100%;
    overflow: scroll;
}

.publishers-list {
    list-style-type: none;
    padding: 0px;
}

.empty-list {
    color: #777777;
    font-size: 36px;
    font-weight: bold;
    margin-top: 64px;
    text-align: center;
}

.header {
    border-bottom: 1px solid #999999;
    font-weight: bold;
    margin-top: 16px;
}

.scrolling-area {
    width: 100%;
    height: 100%;
}

.publisher-container {
    display: grid;
    grid-template-columns: 600px auto;
    grid-template-rows: auto auto auto auto;
    grid-template-areas: "title actions" "content ." "parameters parameters" "separator separator";
    margin-bottom: 8px;
}

.publisher-badges {
    grid-area: badges;
}

.publisher-title {
    grid-area: title;
    font-weight: bold;
}

.publisher-content {
    grid-area: content;
    color: #555555;
    white-space: pre-line;
}

.publisher-parameters {
    grid-area: parameters;
    color: #555555;
    font-size: 12px;
}

.publisher-actions {
    grid-area: actions;
}

.publisher-actions button {
    margin: 0px 4px;
}

.publisher-container hr {
    grid-area: separator;
}

.start-date-input {
    display: inline;
    margin-left: 8px;
    width: auto;
}

.end-date-input {
    display: inline;
    margin-left: 8px;
    width: auto;
}
</style>
